import { ONE_DAY } from '@/app/constants';
import { safeStorage } from '@/app/utils/client';

const DOWNLOAD_KEY = 'VIDU_DOWNLOAD_TIME';

/** 获取自然日字符串 'YYYY-MM-DD'（本地时区） */
export const getTodayDate = () => new Date().toLocaleDateString('en-CA');

// 下载提醒 hook
export const useDownloadAlertPricing = () => {
  const getIsAlertPricing = () => {
    const lastAlertTime = safeStorage.getItem(DOWNLOAD_KEY);
    return !lastAlertTime || Date.now() - Number(lastAlertTime) >= ONE_DAY;
  };

  const markAsShown = () => {
    safeStorage.setItem(DOWNLOAD_KEY, Date.now().toString());
  };

  return {
    getIsAlertPricing,
    markAsShown,
  };
};
